import {
    Injectable,
} from '@angular/core';

import type {
    PrepaidMovementsFields,
} from 'src/app/features/customers/customers.model';

import {
    FidelitiesPoints,
} from 'tilby-models';

import {
    Subject,
} from 'rxjs';

/**
 * Customer data that changed on another device and reached this one through the IoT channel. `IotMessageManager` pushes
 * the values, the customer screens listen.
 */
@Injectable({
    providedIn: 'root',
})
export class IotCustomerUpdatesService {
    public readonly fidelityPoints$ = new Subject<FidelitiesPoints>();

    public readonly prepaidCredit$ = new Subject<PrepaidMovementsFields>();
}
